if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this.sku = this.dataset.gopuffProductId;
      if (!this.sku) return;

      this.quantityPill = this.querySelector('quantity-pill');
      if (!this.quantityPill) return;

      this.checkProductAvailability();
      subscribe(PUB_SUB_EVENTS.deliveryLocationUpdate, this.checkProductAvailability.bind(this));
    }

    checkProductAvailability() {
      const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));
      if (!deliveryLocation) {
        return;
      };

      const params = {
        country_code: deliveryLocation.delivery_zone.country_code,
        location_id: deliveryLocation.delivery_zone.id,
        product_ids: this.sku,
      };

      fetch(`${window.gopuffShopify.settings.api_base_url}/products?${new URLSearchParams(params)}`)
        .then((response) => response.json())
        .then((response) => {
          if (response.products) {
            response.products.forEach((product) => {
              this.quantityPill.setMax(product.quantity);
              this.quantityPill.validateQtyRules();
            });
          }
        });
    }
  }
  )
};



